import { render, staticRenderFns } from "./identityInfo.vue?vue&type=template&id=16d816a7&scoped=true&"
import script from "./identityInfo.vue?vue&type=script&lang=js&"
export * from "./identityInfo.vue?vue&type=script&lang=js&"
import style0 from "./identityInfo.vue?vue&type=style&index=0&id=16d816a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d816a7",
  null
  
)

export default component.exports